export type ProductPrioritiesNorthStarRow = {
  monthStart: string;
  snapshotDate: string | null;
  alignedCarespaces: number | null;
};

export type ProductPrioritiesEfficiencyRow = {
  monthStart: string;
  snapshotDate: string | null;
  assignedAlignedCarespaces: number | null;
  navigatorsWithAlignedCarespaces: number | null;
  alignedPerNavigator: number | null;
};

export type ProductPrioritiesLoadDistributionRow = {
  userId: string;
  navigatorName: string;
  alignedCarespaces: number;
};

export type ProductPrioritiesDeferredMetric = {
  key: string;
  label: string;
  reason: string;
};

export type ProductPrioritiesResponse = {
  asOf: string;
  targetAlignedCarespaces: number;
  northStarRows: ProductPrioritiesNorthStarRow[];
  careNavigationEfficiencyRows: ProductPrioritiesEfficiencyRow[];
  currentCarryingLoadRows: ProductPrioritiesLoadDistributionRow[];
  deferredMetrics: ProductPrioritiesDeferredMetric[];
};

export function isProductPrioritiesResponse(value: unknown): value is ProductPrioritiesResponse {
  if (!value || typeof value !== "object") {
    return false;
  }
  const body = value as Partial<ProductPrioritiesResponse>;
  return (
    typeof body.asOf === "string" &&
    typeof body.targetAlignedCarespaces === "number" &&
    Array.isArray(body.northStarRows) &&
    Array.isArray(body.careNavigationEfficiencyRows) &&
    Array.isArray(body.currentCarryingLoadRows) &&
    Array.isArray(body.deferredMetrics)
  );
}
